<template>
    <div class="modal-content fm-modal-folder">
        <div class="modal-header">
            <h5 class="modal-title">{{ $t('filemanager.modal.newFile.title') }}</h5>
            <button type="button" class="close" aria-label="Close" v-on:click="hideModal">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <label for="fm-file-name">{{ $t('filemanager.modal.newFile.fieldName') }}</label>
                <input type="text" class="form-control" id="fm-file-name"
                       v-focus
                       v-bind:class="{'is-invalid': fileExist}"
                       v-model="fileName"
                       v-on:keyup="validateFileName"><br>
                <!-- <label for="fm-file-name">{{ $t('filemanager.modal.newFile.type') }}</label>
                <select class="form-control" v-model="selectedType">
                  <option :value="docType.id" v-for="docType in documentTypes" :key="docType.id">
                    {{ docType.name }}
                  </option>
                </select> -->
                <small class="feedback" v-show="checkSpecialChar">
                    {{ $t('filemanager.modal.newFile.checkChar') }}
                </small>
                <div class="invalid-feedback" v-show="fileExist">
                    {{ $t('filemanager.modal.newFile.fieldFeedback') }}
                </div>
                
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-info"
                    v-bind:disabled="!submitActive"
                    v-on:click="addFile">{{ $t('filemanager.btn.submit') }}
            </button>
            <button class="btn btn-light" v-on:click="hideModal">{{ $t('filemanager.btn.cancel') }}</button>
        </div>
    </div>
</template>

<script>
import modal from '../mixins/modal';
import { mapActions } from "vuex";

export default {
  name: 'NewWordFile',
  mixins: [modal],
  data() {
    return {
      fileName: '',
      fileExist: false,
      documentTypes: [],
      selectedType: 1,
    };
  },
  computed: {
    /**
     * Submit button - active or no
     * @returns {string|boolean}
     */
    submitActive() {
      return this.fileName && !this.fileExist && this.selectedType !== '' && !this.checkSpecialChar;
    },
    checkSpecialChar() {
      var pattern = /[*'":\\|<>/?]/
      let valid = false;
      if(pattern.test(this.fileName)) {
        valid = true;
      }
      return valid;
    },
  },
  methods: {
    ...mapActions(["getDocumentTypes"]),
    /**
     * Check the file name if it exists or not.
     */
    validateFileName() {
      if (this.fileName) {
        this.fileExist = this.$store.getters[`${this.activeManager}/fileExist`](this.fileName);
      } else {
        this.fileExist = false;
      }
    },

    /**
     * Create new file
     */
    addFile() {
      // TODO: add extension variable in data to make the function generic
      const payload = {
        fileName: `${this.fileName}.xlsx`,
        fileTypeId: this.selectedType,
        officeType: 'xls'
      };
      this.$store.dispatch('createFile', payload)
        .then((response) => {
          this.$store.commit('messages/addLoading');
          // if new directory created successfully
          if (response.data.result.status === 'success') {
            // close modal window
            this.hideModal();
          }
        })
        .finally(() => {
          this.$store.commit('messages/subtractLoading');
        });
    },
  },
  created() {
    this.getDocumentTypes().then((response) => {
        if (response.status == 200) {
          this.documentTypes = response.data.data;
        }
      })
      .catch(() => {});
  }
};
</script>

<style>
  .feedback {
    color: red;
  }
</style>
